import type { StyleSpecification } from 'maplibre-gl';

import { DEFAULT_MAP_BACKGROUND_COLOUR } from './presentation';

export function createNeutralMapStyle(
  backgroundColour = DEFAULT_MAP_BACKGROUND_COLOUR,
): StyleSpecification {
  return {
    version: 8,
    name: 'Placeio Maps neutral foundation',
    sources: {},
    layers: [
      {
        id: 'dropmap-background',
        type: 'background',
        paint: {
          'background-color': backgroundColour,
        },
      },
    ],
  };
}
